import { shiftApplicationService } from 'hq/services';
import { useMutation } from 'react-query';

type ShiftApplicationMutationParams = {
  shiftApplicationId: string;
  flexWorkerId: string;
};

export const useHqAcceptShiftApplication = () => {
  const mutationFn = async (params: ShiftApplicationMutationParams) =>
    await shiftApplicationService.acceptShiftApplication(
      params.shiftApplicationId,
      params.flexWorkerId
    );

  return useMutation(mutationFn);
};
